import { storyQueryScope, type StoryQueryKey } from './storyQueryKeyBase';

const root = storyQueryScope('timber-prices');

export const timberPriceQueryKeys = Object.freeze({
  all: root,
  reportSnapshot: (args: {
    region: string;
    harvestType: string;
    assortment: string;
    windowMonths: number;
    dateFrom: string;
    dateTo: string;
  }): StoryQueryKey =>
    Object.freeze([
      ...root,
      'report-snapshot',
      args.region,
      args.harvestType,
      args.assortment,
      args.windowMonths,
      args.dateFrom,
      args.dateTo,
    ]),
});
